<template>
  <v-container fluid>
    <div class="mt-n10"></div>
    <v-row
      v-for="categoria in categorias"
      :key="categoria.categoria"
      class="my-10 mx-auto"
    >
      <v-col cols="12" class="pb-0">
        <h2 class="titulo">
          {{ categoria.categoria }}
        </h2>
      </v-col>
      <v-col
        class=""
        xs="12"
        sm="6"
        md="4"
        xl="3"
        v-for="(painel, _key) in categoria.paineis"
        :key="_key"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-hover v-slot:default="{ hover }">
              <v-card
                :class="!painel.ativo ? 'disabled-card' : ''"
                :style="hover && !painel.ativo ? 'cursor: not-allowed' : ''"
                id="caixa-painel"
                class="mx-2 d-flex justify-center"
                min-width="200px"
                height="100%"
                raised
                :color="hover && painel.ativo ? 'grey lighten-2' : 'white'"
                elevation="0"
                :to="!painel.ativo ? '' : `/paineis-gerenciais/${painel.slug}`"
                v-bind="attrs"
                v-on="on"
              >
                <hint
                  v-if="!painel.ativo"
                  msgModal="Este relatório está inativo. Para mais informações, entre em contato com o administrador do sistema."
                />
                <v-row no-gutters align="center" justify="center">
                  <v-col cols="2">
                    <v-icon
                      class="my-auto d-flex justify-center"
                      :size="40"
                      color="primary"
                    >
                      {{ painel.icone }}
                    </v-icon>
                  </v-col>
                  <v-col cols="10">
                    <v-card-text class="mx-auto my-auto">
                      <div class="subtitle-2" style="word-break: normal">
                        {{ painel.nome | truncate(45) }}
                      </div>
                      <div class="caption text--secondary">
                        {{ painel.descricao ? painel.descricao : "" }}
                      </div>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card>
            </v-hover>
          </template>
          {{ painel.nome }}
        </v-tooltip>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {
    Hint: () => import("@/components/general/Hint"),
  },
  data: () => ({
    categorias: [
      {
        categoria: "Painéis Internos",
        paineis: [
          {
            nome: "Dashboard Geral",
            descricao: "Dashboard com a Visão Geral dos Indicadores",
            slug: "dashboard-geral",
            ativo: true,
            icone: "mdi-chart-areaspline",
          },
          {
            nome: "Dashboard LNO",
            descricao: "Dashboard Ligação com Obras",
            slug: "dashboard-lno",
            ativo: true,
            icone: "mdi-chart-areaspline",
          },
          {
            nome: "Dashboard de Serviços",
            descricao: "Dashboard de Serviços",
            slug: "dashboard-servicos",
            ativo: true,
            icone: "mdi-chart-areaspline",
          },
          {
            nome: "Dashboard de ISFP/PSFP",
            descricao: "Dashboard de Indicadores Regulatórios",
            slug: "dashboard-isfp-psfp",
            ativo: true,
            icone: "mdi-chart-areaspline",
          },
          {
            nome: "Dashboard Serviços por Área",
            descricao: "Dashboard de Serviços por Área e Gerência",
            slug: "servicos-area",
            ativo: true,
            icone: "mdi-chart-areaspline"
          },
          {
            nome: "Dashboard de Faturamento",
            descricao: "Dashboard de Faturamento",
            slug: "dashboard-faturamento",
            ativo: true,
            icone: "mdi-chart-areaspline",
          },
          {
            nome: "Dashboard de Ressarcimento de Danos Elétricos",
            descricao: "Dashboard de Ressarcimento de Danos Elétricos",
            slug: "dashboard-ressarcimento-danos-eletricos",
            ativo: true,
            icone: "mdi-chart-areaspline",
          },
          {
            nome: "Dashboard Cobranças por Irregularidades",
            descricao: "Dashboard Cobranças por Irregularidades",
            slug: "dashboard-cobrancas-por-irregularidades",
            ativo: true,
            icone: "mdi-chart-areaspline",
          },
          {
            nome: "Dashboard de Religação",
            descricao: "Dashboard de Religação",
            slug: "dashboard-religacao",
            ativo: true,
            icone: "mdi-chart-areaspline",
          },
        ],
      },
      {
        categoria: "Dados Abertos ANEEL",
        paineis: [
          {
            nome: "Painel Brasil",
            descricao: "Dados nacionais das distribuidoras",
            slug: "painel-brasil",
            ativo: true,
            icone: "mdi-chart-areaspline",
          },
          {
            nome: "Dashboard Reclamação", // Antigo 'Dashboard Anexo I - SAC'
            descricao: "Dashboard Reclamação",
            slug: "dashboard-reclamacao",
            ativo: true,
            icone: "mdi-chart-areaspline",
          },
        ],
      },
      {
        categoria: "Demais Relatórios",
        paineis: [
          {
            nome: "Dashboard Nível de Tensão",
            descricao: "Dashboard Nível de Tensão",
            slug: "dashboard-nivel-tensao",
            ativo: true,
            icone: "mdi-chart-areaspline",
          },
        ],
      },
      // {
      //   categoria: "BDGD",
      //   paineis: [
      //     {
      //       nome: "Dashboard BDGD x INDGER",
      //       descricao: "Dashboard comparativo da BDGD e INDGER",
      //       slug: "dashboard-bdgd-indger",
      //       ativo: true,
      //       icone: "mdi-chart-areaspline"
      //     },
      //   ]
      // }
    ],
  }),
};
</script>

<style>
.disabled-card {
  opacity: 0.5;
  border-color: transparent !important;
}
.titulo {
  font-family: "styrene A";
  font-weight: 500;
  color: #3c4858 !important;
  font-size: 18px !important;
}
</style>
